import React from 'react';
import { InputField } from './InputField';
import { TextareaField } from './TextareaField';
import { dynamicInputType, InputTypes } from '../types';
import { generateTestId } from '@/utils/shared/generateTestIds';

const renderByInputType = ({ type, name, label, inputGroup, control, errors }: dynamicInputType) => {
  switch (type) {
    case InputTypes.INPUT:
      return (
        <InputField
          key={name}
          name={name}
          label={label}
          control={control}
          dataTestId={`field_${generateTestId(label)}`}
        />
      );
    case InputTypes.TEXT_AREA:
      return (
        <TextareaField
          key={name}
          name={name}
          label={label}
          control={control}
          errors={errors}
          dataTestId={`field_${generateTestId(label)}`}
        />
      );
    case InputTypes.INPUT_GROUP:
      return (
        <div key={name} className="flex items-center justify-between">
          {inputGroup?.map((el) => (
            <InputField
              key={el.name}
              name={el.name}
              label={el.label}
              control={control}
              classNames={{ input: 'min-w-fit' }}
              dataTestId={`field_${generateTestId(el.label)}`}
            />
          ))}
        </div>
      );
  }
};

export const renderDynamicInputList = (inputList: dynamicInputType[]) => {
  return inputList.map((inputEl) => renderByInputType(inputEl));
};
